import { Box } from '@mui/material';
import {
  GridRenderCellParams,
  gridFilteredDescendantCountLookupSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import { PACING_STATUS_COLORS, PACING_STATUS_LABELS } from '../../../constants/pacing';

const PacingStatus = ({ value, rowNode }: GridRenderCellParams) => {
  const apiRef = useGridApiContext();
  const filteredDescendantCountLookup = useGridSelector(apiRef, gridFilteredDescendantCountLookupSelector);
  const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

  if (filteredDescendantCount) {
    return null;
  }

  return (
    <Box
      sx={{
        padding: '4px 10px',
        borderRadius: '4px',
        background: PACING_STATUS_COLORS[value],
        color: 'white',
        fontSize: 12,
        fontFamily: 'Manrope',
        fontWeight: 600,
      }}
    >
      {PACING_STATUS_LABELS[value]}
    </Box>
  );
};

export default PacingStatus;
